// extracted by mini-css-extract-plugin
export default {"container":"style_container__qZYjt","header":"style_header__B+LAq","serverTime":"style_serverTime__B9ASI"};